<template>
  <div>
    <Row id='statistics' ref="statistics">
      <Col span="24">
        <Card style="margin-bottom: 10px">
          <span class="title">数据统计</span>
          <h3 style="color: red;display:inline-block;">（实时数据）</h3>
          <br>
          <Form inline>
            <FormItem style="margin-bottom: 0">
              <Col span="12">
                <DatePicker type="datetimerange" @on-change="timeChange" :options="timeOptions"
                            :value='searchConf.searchTime' placeholder="选择时间" format="yyyy-MM-dd"
                            style="width: 200px"></DatePicker>
              </Col>
            </FormItem>
            <FormItem style="margin-left: 10px">
              <Input v-model="searchConf.username" @on-change="searchConf.agentname = ''" placeholder="请输入会员名称"></Input>
            </FormItem>
            <FormItem style="margin-left: 10px">
              <Input v-model="searchConf.agentname" @on-change="searchConf.username = ''" placeholder="请输入代理名称"></Input>
            </FormItem>
            <FormItem style="margin-left: 20px">
              <Button type="primary" @click="search" icon="ios-search">{{ $t('find_button') }}</Button>
            </FormItem>
            <FormItem style="margin-bottom: 0">
              <Button type="primary" @click="Day1" icon="ios-search">今天</Button>
            </FormItem>
            <FormItem style="margin-bottom: 0">
              <Button type="primary" @click="Day2" icon="ios-search">昨天</Button>
            </FormItem>
            <FormItem style="margin-bottom: 0">
              <Button type="primary" @click="Day3" icon="ios-search">昨天~今天</Button>
            </FormItem>
            <FormItem style="margin-bottom: 0">
              <Button type="primary" @click="Onday" icon="ios-search">上一天</Button>
            </FormItem>
            <FormItem style="margin-bottom: 0">
              <Button type="primary" @click="Nextday" icon="ios-search">下一天</Button>
            </FormItem>
            <FormItem style="margin-bottom: 0">
              <Button type="primary" @click="Day4" icon="ios-search">本周</Button>
            </FormItem>
            <FormItem style="margin-bottom: 0">
              <Button type="primary" @click="Day5" icon="ios-search">上周</Button>
            </FormItem>
            <FormItem style="margin-bottom: 0">
              <Button type="primary" @click="Day6" icon="ios-search">本月</Button>
            </FormItem>
            <FormItem style="margin-bottom: 0">
              <Button type="primary" @click="Day7" icon="ios-search">上月</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>
    <Row id="lottery" ref="lottery">
      <Col span="24">
        <Card style="overflow :hidden">
          <ul class="icon">
            <li>
              <Icon type="md-trending-up" size="35" color="#ef3c39"/>
              <strong>
                <p>公司输赢
                  <Icon type="ios-information-circle-outline" class="info-winning" @click="" color='#2d8cf0' size='20'/>
                </p>
                <span :style="{color:  '#ef3c39' }">{{ 0 || 0.00 }}</span>
              </strong>
            </li>

            <li>
              <Icon type="logo-yen" size="35" color="#ef3c39"/>
              <strong>
                <p>代理返点</p>
                <span style="color:#ef3c39">{{ 0 || 0.00 }}</span>
              </strong>
            </li>
            <li>
              <Icon type="md-person-add" size="35" color="#f7ae4a"/>
              <strong>
                <p>平台活动</p>
                <span
                  style="color:#ef3c39">{{ 0 || 0.00 }} / {{ 0 || 0.00 }}</span>
              </strong>
            </li>
            <li>
              <Icon type="md-bookmarks" size="35" color="#ef3c39"/>
              <strong>
                <p>送出红包</p>
                <span style="color:#ef3c39">{{ 0 || 0.00 }}</span>
              </strong>
            </li>
            <li>
              <Icon type="md-code-download" size="35" color="#21b242"/>
              <strong>
                <p>游戏人数</p>
                <span class="out-line" @click=""
                      style="color:#ef3c39">{{ 0 || 0 }}</span>
              </strong>
            </li>
            <li>
              <Icon type="md-person" size="35" color="#4a92ef"/>
              <strong>
                <p>新增会员</p>
                <span class="out-line" @click=""
                      style="color:#ef3c39">{{ 0 || 0 }}</span>
              </strong>
            </li>
          </ul>
        </Card>
      </Col>
    </Row>
    <Row id="vessel" ref="vessel">
      <Col span="8" id="one" ref="one" style="margin-top : 10px;">
        <Card>
        <span slot="title">
          <Icon type="md-star-half" size="20" color="#ef3c39"/>
          <span class="header">投注游戏</span>
          <span class="ml20"></span>
          <strong class="trunk fontred out-line"
                  @click=""> {{ 0 || 0 }}人</strong>
        </span>

          <span class="circle"></span> <span class="caption">投注金额</span>
          <del class="person">{{ 0 || 0.00 }}</del>
          <br>
          <span class="circle green"></span> <span class="caption">中奖金额</span>
          <del class="person">{{ 0 || 0.00 }}</del>
          <br>
          <span class="circle red"></span> <span class="caption">投注游戏输赢</span>
          <del class="person">{{ 0 || 0.00 }}</del>
          <br>
        </Card>
        <Card style="margin-top : 10px">
        <span slot="title">
          <Icon type="ios-game-controller-a" size="20" color="#f7ae4a"/>
          <span class="bold">涨跌游戏 </span>
          <span class="ml20"></span>
          <strong class="users fontred out-line"
                  @click="">{{ 0 || 0 }}人</strong>
        </span>
          <span class="circle"></span> <span class="caption">投注金额</span>
          <del class="person">{{ 0 || 0.00 }}</del>
          <br>
          <span class="circle"></span> <span class="caption">中奖金额</span>
          <del class="person">{{ 0 || 0.00 }}</del>
          <br>
          <span class="circle red"></span> <span class="caption">涨跌游戏输赢</span>
          <del class="person">{{ 0 || 0.00 }}</del>
          <br>
        </Card>
        <Card style="margin-top : 10px">
        <span slot="title">
          <Icon type="md-cash" size="20" color="#f7ae4a"/>
          <span class="bold">杠杆游戏 </span>
          <span class="ml20"></span>
          <strong class="users fontyellow out-line"
                  @click=""> {{ 0 || 0 }} 人</strong>
        </span>
          <span class="circle"></span> <span class="caption">购买合约</span>
          <del class="person">{{ 0 || 0.00 }}</del>
          <br>
          <span class="circle green"></span> <span class="caption">出售合约</span>
          <del class="person">{{ 0 || 0.00 }}</del>
          <br>
          <span class="circle red"></span> <span class="caption">管理费</span>
          <del class="person">{{ 0 || 0.00 }}</del>
          <br>
          <span class="circle green"></span> <span class="caption">手续费</span>
          <del class="person">{{ 0 || 0.00 }}</del>
          <br>
          <span class="circle green"></span> <span class="caption">合约输赢</span>
          <del class="person">{{ 0 || 0.00 }}</del>


        </Card>
        <Card style="margin-top : 10px">
        <span slot="title">
          <Icon type="md-contacts" size="20" color="#ef3c39"/>
          <span class="bold">理财游戏 </span>
                 <span class="ml20"></span>
          <strong class="users fontyellow out-line"
                  @click=""> {{ 0 || 0 }} 人</strong>
        </span>
          <span class="circle"></span> <span class="caption">理财购入 <del
          class="person">{{ 0 || 0.00 }}</del></span> <br>
          <span class="circle green"></span> <span class="caption">理财到期 <del
          class="person">{{ 0 || 0.00 }}</del></span> <br>
          <span class="circle green"></span> <span class="caption">理财出售 <del
          class="person">{{ 0 || 0.00 }}</del></span> <br>
          <span class="circle green"></span> <span class="caption">理财支付利息<del
          class="person">{{ 0 || 0.00 }}</del></span> <br>
          <span class="circle green"></span> <span class="caption">理财提前出售收益 <del
          class="person">{{ 0 || 0.00 }}</del></span> <br>
          <span class="circle green"></span> <span class="caption">理财游戏输赢 <del
          class="person">{{ 0 || 0.00 }}</del></span> <br>
        </Card>

      </Col>
      <Col span="7" id="two" ref="two" style="margin-top : 10px;" class="margin">
        <Card>
        <span slot="title">
        <Icon type="md-contacts" size="20" color="#ef3c39"/>
          <span class="bold">区块游戏 </span>
          <span class="ml20"></span>
          <strong class="users fontyellow out-line"
                  @click=""> {{ 0 || 0 }} 人</strong>
        </span>
          <span class="circle"></span> <span class="caption">区块投注金额 <del
          class="person">{{ 0 || 0.00 }}</del></span> <br>
          <span class="circle green"></span> <span class="caption">区块中奖金额 <del
          class="person">{{ 0 || 0.00 }}</del></span> <br>
          <span class="circle green"></span> <span class="caption">区块游戏输赢 <del
          class="person">{{ 0 || 0.00 }}</del></span> <br>
        </Card>
        <Card style="margin-top : 10px">
        <span slot="title">
          <Icon type="logo-yen" color="#21b242" size="20"/>
          <span class="header">代理总计</span>

        </span>
          <span class="circle"></span> <span class="caption">代理总返点</span>
          <del class="person">{{ 0 || 0.00 }}</del>
          <br>
          <span class="circle green"></span> <span class="caption">投注游戏返点</span>
          <del class="person">{{ 0 || 0.00 }}</del>
          <br>
          <span class="circle red"></span> <span class="caption">涨跌游戏返点</span>
          <del class="person">{{ 0 || 0.00 }}</del>
          <br>
          <span class="circle "></span> <span class="caption">杠杆游戏返点</span>
          <del class="person">{{ 0 || 0.00 }}</del>
          <br>
          <span class="circle "></span> <span class="caption">理财游戏返点</span>
          <del class="person">{{ 0 || 0.00 }}</del>
          <br>
        </Card>
        <Card style="margin-top : 10px">
        <span slot="title">
          <Icon type="ios-game-controller-b" size="20" color="red"/>
          <span class="bold">优惠总计</span>
          <span class="ml20"></span>
          <strong class="users fontyellow"> {{ 0 || 0.00 }}</strong>
        </span>
          <span class="circle"></span> <span class="caption">人工赠送</span>
          <del class="person">{{ 0 || 0.00 }}</del>
          <br>
          <span class="circle green"></span> <span class="caption">活动申请赠送</span>
          <del class="person">{{ 0 || 0.00 }}</del>
          <br>
          <span class="circle red"></span> <span class="caption">充值优惠赠送</span>
          <del class="person">{{ 0 || 0.00 }}</del>
        </Card>

        <Card style="margin-top : 10px">
        <span slot="title">
          <Icon type="md-git-compare" size="20" color="#ef3c39"/>
          <span class="bold">平台财富总额 </span>
        </span>
          <span class="circle"></span> <span class="caption">用户帐户余额</span>
          <del class="person">{{ 0 || 0.00 }}</del>
          <br>
          <span class="circle green"></span> <span class="caption">杠杆合约金额</span>
          <del class="person">{{ 0 || 0.00 }}</del>
          <br>
          <span class="circle red"></span> <span class="caption">理财游戏余额</span>
          <del class="person">{{ 0 || 0.00 }}</del>
          <br>
        </Card>
      </Col>
      <Col span="8" id="three" ref="three" style="margin-top : 10px;">
        <Card>
        <span slot="title">
          <Icon type="ios-card" color="#ef3c39" size="20"/>
          <span class="bold">充值总计</span>
          <span class="ml20"></span>
          <strong class="users fontred out-line"
                  @click=""> {{
              0 || 0.00
            }}  /  {{ 0 || 0 }}人</strong>
          <strong
            class="users fontred"> （实际充值{{ 0 || 0.00 }}  /  {{
              0 || 0
            }}人）</strong>
        </span>
          <span class="circle"></span> <span class="caption">USDT入款</span>
          <del class="person out-line" @click="">{{ 0 || 0.00 }} /
            {{ 0 }}笔
          </del>
          <br>
          <span class="circle"></span> <span class="caption">银行转帐入款</span>
          <del class="person out-line" @click="">{{ 0 || 0.00 }} /
            {{ 0 }}笔
          </del>
          <br>
          <span class="circle green"></span> <span class="caption">微信付款</span>
          <del class="person out-line" @click="">{{ 0 || 0.00 }} /
            {{ 0 || 0 }}笔
          </del>
          <br>
          <span class="circle fontyellows"></span> <span class="caption">支付宝付款</span>
          <del class="person out-line" @click="">{{ 0 || 0.00 }} /
            {{ 0 || 0 }}笔
          </del>
          <br>
          <span class="circle red"></span> <span class="caption">快捷支付</span>
          <del class="person out-line" @click="">{{ 0 || 0.00 }} /
            {{ 0 || 0 }}笔
          </del>
          <br>
          <span class="circle "></span> <span class="caption">人工入款</span>
          <del class="person">{{ 0 || 0.00 }} / {{ 0 || 0 }}笔</del>
          <br>
          <span class="circle "></span> <span class="caption">人工入款(不计报表)</span>
          <del class="person">{{ 0 || 0.00 }} / {{ 0 || 0 }}笔</del>
          <br>
          <span class="circle"></span> <span class="caption">其它三方方式入款</span>
          <del class="person out-line" @click="">{{ 0 || 0.00 }} /
            {{ 0 }}笔
          </del>
          <br>
          <span class="circle green"></span> <span class="caption">首次入款</span>
          <del class="person out-line" @click="">
            {{ 0 || 0.00 }} / {{ 0 || 0 }}人
          </del>
          <br>
          <span class="circle fontyellows"></span> <span class="caption">二次入款</span>
          <del class="person out-line" @click="">
            {{ 0 || 0.00 }} / {{ 0 || 0 }}人
          </del>
          <br>
        </Card>
        <Card style="margin-top : 10px">
        <span slot="title">
          <Icon type="md-document" size="20" color="#ef3c39"/>
          <span class="bold">提现总计 &nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span class="ml20"></span>
          <strong class="users fontred out-line"
                  @click="">{{
              0 || 0.00
            }} / {{ 0 || 0 }}人</strong>
        </span>
          <span class="circle"></span> <span class="caption">USDT出款</span>
          <del class="person">{{ 0 || 0.00 }} / {{ 0 || 0 }}笔</del>
          <br>
          <span class="circle"></span> <span class="caption">银行卡出款</span>
          <del class="person">{{ 0 || 0.00 }} / {{ 0 || 0 }}笔</del>
          <br>
          <span class="circle green"></span> <span class="caption">人工出款</span>
          <del class="person">{{ 0 || 0.00 }} /
            {{ 0 || 0 }}笔
          </del>
          <br>
          <span class="circle"></span> <span class="caption">人工出款(不计报表)</span>
          <del class="person">{{ 0 || 0.00 }} /
            {{ 0 || 0 }}笔
          </del>
          <br>
          <span class="circle red"></span> <span class="caption">第三方出款</span>
          <del class="person">{{ 0 || 0.00 }} / {{ 0 || 0 }}笔
          </del>
          <br>
          <span class="circle fontyellows"></span> <span class="caption">首次提现</span>
          <del class="person out-line" @click="">
            {{ 0 || 0.00 }} / {{ 0 || 0 }}人
          </del>
          <br>
          <span class="circle"></span> <span class="caption">二次提现</span>
          <del class="person out-line" @click="">
            {{ 0 || 0.00 }} / {{ 0 || 0 }}人
          </del>
          <br>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>

import {
  getDate
} from '@/libs/tools.js'
import {
  week,
  month,
  onMonth,
  getTime,
  yesterday,
  today,
  Fromday,
  formattingMonth,
  lastMonthDate,
} from '@/libs/time'

export default {
  name: 'home',
  data () {
    return {
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value () {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value () {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value () {
              return lastMonthDate()
            }
          },
        ]
      },
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 10,
        listCount: 0,
        allDama: 0,
        playDama: 0,
        remainDame: 0
      },
      searchConf: { searchTime: [], }, // 搜索字段
      extraParams: [],
      listLoading: false, //显示加载中状态

    }
  },
  mounted () {
    //
  },
  methods: {
    timeChange (datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    search () {
      this.tableShow.currentPage = 1
      this.getList()
    },
    // 今天
    Day1 () {
      //this.timer = today().join(" - ");
      this.searchConf.searchTime = [today()[0] + ' 00:00:00', today()[0] + ' 23:59:59']
      this.getList()
    },
    //昨天
    Day2 () {
      this.searchConf.searchTime = [yesterday()[0] + ' 00:00:00', yesterday()[0] + ' 23:59:59']
      this.getList()
    },
    //昨天到今天
    Day3 () {
      this.searchConf.searchTime = [Fromday()[0] + ' 00:00:00', Fromday()[1] + ' 23:59:59']
      this.getList()
    },
    //本周
    Day4 () {
      this.searchConf.searchTime = [week()[0] + ' 00:00:00', week()[1] + ' 23:59:59']
      this.getList()
    },
    //上周
    Day5 () {
      this.searchConf.searchTime = [getTime(7) + ' 00:00:00', getTime(1) + ' 23:59:59']
      this.getList()
    },
    //本月
    Day6 () {
      this.searchConf.searchTime = [month()[0] + ' 00:00:00', month()[1] + ' 23:59:59']
      this.getList()
    },
    //上月
    Day7 () {
      this.searchConf.searchTime = [onMonth()[0] + ' 00:00:00', onMonth()[1] + ' 23:59:59']
      this.getList()
    },
    Onday () {
      if (typeof this.searchConf.searchTime[0] == 'undefined') {
        this.searchConf.searchTime = [today()[0] + ' 00:00:00', today()[0] + ' 23:59:59']
      }
      var s = this.searchConf.searchTime[0]
      var d = new Date(Date.parse(s.replace(/-/g, '/')))
      d.setDate(d.getDate() - 1)
      var t = [d.getFullYear(), d.getMonth() + 1, d.getDate()]
      this.searchConf.searchTime = [t.join('-') + ' 00:00:00', t.join('-') + ' 23:59:59']
      this.getList()
    },
    Nextday () {
      if (typeof this.searchConf.searchTime[0] == 'undefined') {
        this.searchConf.searchTime = [today()[0] + ' 00:00:00', today()[0] + ' 23:59:59']
      }
      var s = this.searchConf.searchTime[0]
      var d = new Date(Date.parse(s.replace(/-/g, '/')))
      d.setDate(d.getDate() + 1)
      var t = [d.getFullYear(), d.getMonth() + 1, d.getDate()]
      this.searchConf.searchTime = [t.join('-') + ' 00:00:00', t.join('-') + ' 23:59:59']
      this.getList()
    },
  }
}
</script>

<style lang="less" scoped>
#lottery {
  /deep/ .ivu-card-body {
    padding: 0;
  }
}

.ivu-btn {
  padding: 0 5px;
  font-size: 10px;
}

.info-winning {
  vertical-align: top;
  cursor: pointer;
}

.title {
  display: inline-block;
  font-size: 17px;
  color: #000;
  font-weight: 700;
  margin-bottom: 20px;

  strong {
    color: red;
  }
}

.icon {
  width: 100%;
  list-style: none;
  height: 100%;
  overflow: hidden;
  display: flex;

  li {
    flex: 1;
    position: relative;
    float: left;
    overflow: hidden;
    padding: 16px;

    strong {
      vertical-align: bottom;
    }

    p {
      margin-bottom: 0px;
      position: absolute;
      top: 15px;
      left: 60px;
      font-size: 14px;
      white-space: nowrap;
    }

    span {
      position: absolute;
      display: block;
      left: 60px;
      top: 32px;
      color: #21b242;
      font-size: 14px;
      z-index: 10;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.header {
  font-size: 14px;
  font-weight: 700;
  vertical-align: bottom;
  margin-left: 3px;
}

.trunk {
  font-size: 14px;
  font-weight: 700;
  vertical-align: bottom;
  margin-left: 3px;
}

.bold {
  display: inline-block;
  font-weight: 700;
  font-size: 14px;
  vertical-align: middle;
  margin-left: 3px;
}

.users {
  display: inline-block;
  font-size: 14px;
  font-weight: 700;
  vertical-align: middle;
  margin-left: 3px;
}

.circle {
  display: inline-block;
  margin-left: 10px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #4a92ef;
  vertical-align: middle;
  margin-bottom: 15px;
}

.green {
  background-color: #21b242;
}

.red {
  background-color: #ef3c39;
}

.blue {
  background-color: skyblue;
}

.fontyellows {
  background-color: #f7ae4a;
}

.fontgreen {
  color: #21b242;
}

.fontred {
  color: #ef3c39;
}

.fontyellow {
  color: #f7ae4a;
}

.caption {
  display: inline-block;
  color: #313031;
  font-size: 13px;
  margin-left: 10px;
  vertical-align: middle;
  margin-bottom: 15px;
}

.person {
  position: absolute;
  right: 30%;
  display: inline-block;
  color: #4a92ef;
  font-size: 14px;
  vertical-align: middle;
  text-decoration: none;
  margin-bottom: 15px;
}

#boxes {
  margin-top: -60px !important;
  margin-right: 20px;
}

.margin {
  width: 32.166667%;
  margin-right: calc((100% - 66.66666666% - 32.166667%) / 2);
  margin-left: calc((100% - 66.66666666% - 32.166667%) / 2);
}

#journal {
  list-style: none;
  font-size: 15px;

  li {
    margin-bottom: 30px;
  }
}

#position {
  position: relative;

  strong {
    position: absolute;
    top: 0%;
    right: 55%;
  }

  .aaa {
    top: 52%;
    right: 55%;
  }
}

.ml20 {
  display: inline-block;
  width: 20px;
  height: 10px;
}

.out-line {
  cursor: pointer;
  text-decoration: underline;
}

/deep/ .ivu-table-wrapper {
  margin: 2px;
}

/deep/ .ivu-table:after {
  height: 0;
}
</style>

